import { render } from "./ConflictValueDisplay.vue?vue&type=template&id=4cc99235&scoped=true"
import script from "./ConflictValueDisplay.vue?vue&type=script&lang=js"
export * from "./ConflictValueDisplay.vue?vue&type=script&lang=js"

import "./ConflictValueDisplay.vue?vue&type=style&index=0&id=4cc99235&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc99235"]])

export default __exports__